import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// A QueryClientProvider used to wrap this tree, but no component ever called a
// react-query hook — data fetching goes through the usePoll hooks in lib/api.js.
// Dropped along with the dependency.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

